import CONSTANTS from "@/store/constants";

const VGT_PAGINATION_OPTIONS = {
          USER_INVOICE_SUBMISSION_COLUMNS_PAGINATION_OPTIONS : {
                  mode: "records",
                  perPage: CONSTANTS.PAGINATION_THRESHOLD_FIVE,
                  perPageDropdown: [5, 10, 15],
                  dropdownAllowAll: true,
                  position: "bottom",
                  nextLabel: "next",
                  prevLabel: "prev",
                  rowsPerPageLabel: "Rows per page",
                  ofLabel: "of",
                  pageLabel: "page", // for 'pages' mode
                  allLabel: "All"
          },
        COMPLETED_CASE_PAGINATION_CONFIG: {
                mode: "records",
                perPage: CONSTANTS.PAGINATION_THRESHOLD,
                perPageDropdown: [5,10,15],
                dropdownAllowAll: false,
                position: "bottom",
                nextLabel: "next",
                prevLabel: "prev",
                rowsPerPageLabel: "Rows per page",
                ofLabel: "of",
                pageLabel: "page", // for 'pages' mode
                allLabel: "All"
        },
        SUPPLIER_LIST_PAGINATION_OPTIONS: {
                mode: "records",
                perPage: 15,
                perPageDropdown: [15, 30, 50, 100],
                dropdownAllowAll: false,
                position: "bottom",
                nextLabel: "next",
                prevLabel: "prev",
                rowsPerPageLabel: "Rows per page",
                ofLabel: "of",
                pageLabel: "page",
                allLabel: "All",
        },
        PRODUCT_LIST_PAGINATION_OPTIONS: {
                mode: "records",
                perPage: 15,
                perPageDropdown: [15, 30, 50, 100],
                dropdownAllowAll: false,
                position: "bottom",
                nextLabel: "next",
                prevLabel: "prev",
                rowsPerPageLabel: "Rows per page",
                ofLabel: "of",
                pageLabel: "page",
                allLabel: "All",
        },
        DRAFT_STATUS_LIST_PAGINATION_OPTIONS :{
                mode: "records",
                perPage: CONSTANTS.PAGINATION_THRESHOLD,
                perPageDropdown: [5],
                dropdownAllowAll: false,
                position: "bottom",
                nextLabel: "next",
                prevLabel: "prev",
                rowsPerPageLabel: "Rows per page",
                ofLabel: "of",
                pageLabel: "page", // for 'pages' mode
                allLabel: "All"
        },
        INVOICE_DETAIL_PAGINATION_OPTIONS: {
                mode: "records",
                perPage: 10,
                perPageDropdown: [10,20],
                dropdownAllowAll: true,
                position: "bottom",
                nextLabel: "next",
                prevLabel: "prev",
                rowsPerPageLabel: "Rows per page",
                ofLabel: "of",
                pageLabel: "page",
                allLabel: "All"
        },
        INVOICES_DRAFTS_PAGINATION_OPTIONS :{
                mode: "records",
                perPage: CONSTANTS.PAGINATION_THRESHOLD_FIVE,
                perPageDropdown: [5,10,15],
                dropdownAllowAll: true,
                position: "bottom",
                nextLabel: "next",
                prevLabel: "prev",
                rowsPerPageLabel: "Rows per page",
                ofLabel: "of",
                pageLabel: "page", // for 'pages' mode
                allLabel: "All"
        },
        RETURNED_REQUESTS_LIST_PAGINATION_OPTIONS:{
                mode: "records",
                perPage: CONSTANTS.PAGINATION_THRESHOLD,
                perPageDropdown: [5,10,15],
                dropdownAllowAll: false,
                position: "bottom",
                nextLabel: "next",
                prevLabel: "prev",
                rowsPerPageLabel: "Rows per page",
                ofLabel: "of",
                pageLabel: "page", // for 'pages' mode
                allLabel: "All"
        },
        RECENTLY_SUBMITTED_RITM_LIST_PAGINATION_OPTIONS:{
                mode: "records",
                perPage: CONSTANTS.PAGINATION_THRESHOLD,
                perPageDropdown: [5,10,15],
                dropdownAllowAll: false,
                position: "bottom",
                nextLabel: "next",
                prevLabel: "prev",
                rowsPerPageLabel: "Rows per page",
                ofLabel: "of",
                pageLabel: "page", // for 'pages' mode
                allLabel: "All"
        },

}



export default VGT_PAGINATION_OPTIONS